import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrlService } from '../shared-services/api-url.service';
import { BehaviorSubject, Observable, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  customerData = new BehaviorSubject<any>({});
  customerDataAsObservable = this.customerData.asObservable();
  customerFormData = new BehaviorSubject<any>({});
  customerFormDataAsObservable = this.customerFormData.asObservable()
  customerFormDataEvent = new BehaviorSubject<any>({});
  customerFormDataEventAsObservable = this.customerFormDataEvent.asObservable();

  constructor(
    private readonly http: HttpClient,
    private readonly apiUrlService: ApiUrlService
  ) { }

  getCustomers(payload:any):Observable<any> {
    let param = new HttpParams();
    param = param.append('limit', payload.limit);
    param = param.append('currentPage', payload.currentPage)
    return this.http.get<any>(this.apiUrlService.GET_CUSTOMERS, { params: param});
  }

  getCustomerDetails(id:number):Observable<any> {
    return this.http.get<any>(`${this.apiUrlService.GET_CUSTOMER_DETAILS}/${id}`);
  }

  createCustomer(payload: any):Observable<any> {
    return this.http.post<any>(this.apiUrlService.CREATE_CUSTOMER, payload);
  }

  updateCustomer(id: number, payload: any):Observable<any> {
    return this.http.put<any>(`${this.apiUrlService.UPDATE_CUSTOMER}/${id}`, payload);
  }

  deleteCustomer(id: number) {
    return this.http.delete<any>(`${this.apiUrlService.DELETE_CUSTOMER}/${id}`);
  }

sendCustomerData(data: any) {
  this.customerData.next(data);
}

getCustomerDataObservable() {
  return this.customerDataAsObservable;
}

sendCustomerFormData(data: any) {
  const currentValue = this.customerFormData.value;
  console.log(currentValue, data)
  this.customerFormData.next({...currentValue, ...data});
}

getCustomerFormDataObsevable() {
  return this.customerFormDataAsObservable;
}

sendCustomerFormDataEvent(data: any) {
  this.customerFormDataEvent.next(data);
}

getCustomerFormDataEventObsevable() {
  return this.customerFormDataEventAsObservable;
}

}